import React from "react"
import classNames from "classnames"

import { WebSource } from "../../../../model/types"

export default function SourceStatusTag({ source }: { source: WebSource }) {
  return (
    <div
      className={classNames(
        "inline-flex items-center rounded-md h-7 px-2 py-1 text-xs ring-1 ring-inset uppercase font-semibold ",
        {
          "bg-green-50 text-green-700 ring-green-600/20 dark:bg-green-700 dark:text-green-100 dark:ring-green-800/20":
            source.status == "new",
          "bg-red-50 text-red-700 ring-red-600/20 dark:bg-red-700 dark:text-red-100 dark:ring-red-800/20":
            source.status == "queued",
          "bg-blue-50 text-blue-700 ring-blue-600/20 dark:bg-blue-700 dark:text-blue-100 dark:ring-blue-800/20":
            source.status == "read",
        }
      )}
    >
      {source.status}
    </div>
  )
}
